import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let #sections (like Home's #plans) scroll themselves
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}